export default __webpack_public_path__ + "static/media/viaccess-orca_thumbnail.b6adcddc.png";